import { Component, HostBinding, Input } from '@angular/core';

export type CardShapeType = 'square' | 'rounded' | 'circle';

@Component({
  selector: 'app-card',
  template: '<ng-content></ng-content>',
  styleUrls: ['card.component.scss'],
  host: {
    '[class.card-has-elevation]': '!!elevation',
  },
})
export class CardComponent {
  @Input()
  shapeType: CardShapeType = 'rounded';
  @Input()
  elevation = true;

  @HostBinding('class')
  get hostClass() {
    return [`shape-type-${this.shapeType}`].filter((x) => !!x).join(' ');
  }
}
